<template>
  <modal
    name="editFilial"
    height="auto"
    width="900"
    :scrollable="true"
    :clickToClose="false"
  >
    <CloseModal :close="close" />
    <div class="modalbox">
      <div class="modalbox-content">
        <div class="form-body">
          <div class="filial-cabecalho">
            <div class="filial-cabecalho__icone">
              <fa-icon icon="building" />
            </div>
            <div>
              <h5 class="filial-cabecalho__titulo">
                {{ criando ? "Nova filial" : `${filial.id} - ${nomeFilial}` }}
              </h5>
              <span class="filial-cabecalho__subtitulo">
                {{ criando ? "Cadastro manual de filial" : filial.cnpj || "CNPJ não informado" }}
              </span>
            </div>
          </div>

          <div class="section-label section-label--primeira"
            role="button"
            tabindex="0"
            :aria-expanded="secoes.dados ? 'true' : 'false'"
            v-on:click="alternarSecao('dados')"
            @keydown.enter.prevent="alternarSecao('dados')"
            @keydown.space.prevent="alternarSecao('dados')"
          >
            <fa-icon icon="building" class="section-label__icone" />
            Dados da filial
            <fa-icon
              :icon="secoes.dados ? 'chevron-up' : 'chevron-down'"
              class="section-label__seta"
            />
          </div>
          <div v-show="secoes.dados">
            <div v-if="!criando" class="aviso-erp">
              <fa-icon icon="sync-alt" class="aviso-erp__icone" />
              <span>
                Quando a filial vem da integração com o ERP, estes dados são regravados a
                cada sincronização. Para mudá-los de forma definitiva, ajuste o cadastro no ERP.
              </span>
            </div>
            <div class="xrow">
              <div class="col-1-4">
                <div class="form-group">
                  <label>Código <span v-if="criando" class="text-danger">*</span></label>
                  <input class="form-control" v-model="filial.id" :readonly="!criando" />
                </div>
              </div>
              <div class="col-3-4">
                <div class="form-group">
                  <label>Razão social</label>
                  <input class="form-control" v-model="filial.razaosocial" />
                </div>
              </div>
            </div>
            <div class="xrow">
              <div class="col-1-2">
                <div class="form-group">
                  <label>Nome fantasia</label>
                  <input class="form-control" v-model="filial.fantasia" />
                </div>
              </div>
              <div class="col-1-4">
                <div class="form-group">
                  <label>CNPJ</label>
                  <input class="form-control" v-model="filial.cnpj" />
                </div>
              </div>
              <div class="col-1-4">
                <div class="form-group">
                  <label>Inscrição estadual</label>
                  <input class="form-control" v-model="filial.inscricaoestadual" />
                </div>
              </div>
            </div>
            <div class="xrow">
              <div class="col-1-2">
                <div class="form-group">
                  <label>Endereço</label>
                  <input class="form-control" v-model="filial.endereco" />
                </div>
              </div>
              <div class="col-1-4">
                <div class="form-group">
                  <label>Número</label>
                  <input class="form-control" v-model="filial.numero" />
                </div>
              </div>
              <div class="col-1-4">
                <div class="form-group">
                  <label>Complemento</label>
                  <input class="form-control" v-model="filial.complemento" />
                </div>
              </div>
            </div>
            <div class="xrow">
              <div class="col-1-4">
                <div class="form-group">
                  <label>Bairro</label>
                  <input class="form-control" v-model="filial.bairro" />
                </div>
              </div>
              <div class="col-1-4">
                <div class="form-group">
                  <label>Cidade</label>
                  <input class="form-control" v-model="filial.cidade" />
                </div>
              </div>
              <div class="col-1-4">
                <div class="form-group">
                  <label>UF</label>
                  <input class="form-control" maxlength="2" v-model="filial.uf" />
                </div>
              </div>
              <div class="col-1-4">
                <div class="form-group">
                  <label>CEP</label>
                  <input class="form-control" v-model="filial.cep" />
                </div>
              </div>
            </div>
            <div class="xrow">
              <div class="col-1-4">
                <div class="form-group">
                  <label>Telefone</label>
                  <input class="form-control" v-model="filial.telefone" />
                </div>
              </div>
              <div class="col-1-4">
                <div class="form-group">
                  <label>Filial de retirada padrão</label>
                  <input class="form-control" v-model="filial.filialretira_id" />
                </div>
              </div>
              <div class="col-1-2">
                <div class="toggle-row toggle-row--campo">
                  <span class="toggle-row__label">
                    Filial ativa
                    <span class="toggle-row__hint">Filiais inativas não aparecem nos canais de venda</span>
                  </span>
                  <label class="toggle-switch">
                    <input
                      type="checkbox"
                      :checked="+filial.ativo === 1"
                      @change="filial.ativo = $event.target.checked ? 1 : 0"
                    />
                    <span class="toggle-slider"></span>
                    <span class="toggle-text">{{ +filial.ativo === 1 ? "Sim" : "Não" }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="section-label"
            role="button"
            tabindex="0"
            :aria-expanded="secoes.retirada ? 'true' : 'false'"
            v-on:click="alternarSecao('retirada')"
            @keydown.enter.prevent="alternarSecao('retirada')"
            @keydown.space.prevent="alternarSecao('retirada')"
          >
            <fa-icon icon="truck" class="section-label__icone" />
            Retirada
            <fa-icon
              :icon="secoes.retirada ? 'chevron-up' : 'chevron-down'"
              class="section-label__seta"
            />
          </div>
          <div v-show="secoes.retirada">
            <p class="secao-descricao">
              Habilite as filiais em que o cliente pode retirar os pedidos faturados por esta
              filial. Cada uma vira uma opção na seleção de filial do VersoCall, VersoCommerce,
              VersoApp e VersoVendas, na ordem abaixo. Sem nenhuma habilitada, a retirada
              continua na filial de retirada padrão.
            </p>
            <div class="xrow">
              <div class="col-1-2">
                <div class="form-group">
                  <div class="lista-dupla">
                    <div class="lista-dupla__cabecalho">
                      <span>Filiais disponíveis</span>
                      <span class="lista-dupla__contador">{{ filiaisDisponiveis.length }}</span>
                    </div>
                    <div class="lista-dupla__busca">
                      <fa-icon icon="search" class="lista-dupla__busca-icone" />
                      <input
                        type="text"
                        class="lista-dupla__busca-input"
                        placeholder="Buscar filial..."
                        v-model="buscaFilial"
                      />
                    </div>
                    <ul class="lista-dupla__itens">
                      <li
                        v-for="opcao in filiaisDisponiveis"
                        v-bind:key="opcao.id"
                        class="lista-dupla__item"
                        role="button"
                        tabindex="0"
                        v-on:click="habilitarRetira(opcao.id)"
                        @keydown.enter.prevent="habilitarRetira(opcao.id)"
                        :title="'Habilitar ' + opcao.nome"
                      >
                        <span class="lista-dupla__texto">
                          <strong>{{ opcao.id }}</strong> {{ opcao.nome }}
                          <span v-if="opcao.inativa" class="lista-dupla__selo lista-dupla__selo--inativa">inativa</span>
                        </span>
                        <fa-icon icon="plus" class="lista-dupla__acao" aria-hidden="true" />
                      </li>
                      <li v-if="!filiaisDisponiveis.length" class="lista-dupla__vazio">
                        {{ buscaFilial ? "Nenhuma filial encontrada" : "Todas as filiais já estão habilitadas" }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-1-2">
                <div class="form-group">
                  <div class="lista-dupla lista-dupla--vinculadas">
                    <div class="lista-dupla__cabecalho">
                      <span>Habilitadas para retirada</span>
                      <button
                        type="button"
                        class="lista-dupla__limpar"
                        v-if="filiaisRetira.length"
                        aria-label="Remover todas as filiais habilitadas para retirada"
                        v-on:click="filiaisRetira = []"
                      >
                        Limpar
                      </button>
                      <span v-else class="lista-dupla__contador">0</span>
                    </div>
                    <ul class="lista-dupla__itens lista-dupla__itens--sem-busca">
                      <li
                        v-for="(opcao, indice) in filiaisHabilitadas"
                        v-bind:key="opcao.id"
                        class="lista-dupla__item"
                        role="button"
                        tabindex="0"
                        v-on:click="desabilitarRetira(opcao.id)"
                        @keydown.enter.self.prevent="desabilitarRetira(opcao.id)"
                        :title="'Remover ' + rotuloOpcao(opcao)"
                        :aria-label="'Remover ' + rotuloOpcao(opcao) + ' da retirada'"
                      >
                        <span class="lista-dupla__texto">
                          <span class="lista-dupla__ordem">{{ indice + 1 }}º</span>
                          <strong>{{ opcao.id }}</strong> {{ opcao.nome }}
                          <span
                            v-if="String(opcao.id) === String(filial.filialretira_id)"
                            class="lista-dupla__selo"
                            title="Filial de retirada padrão do cadastro"
                          >
                            padrão
                          </span>
                          <span v-if="opcao.inativa" class="lista-dupla__selo lista-dupla__selo--inativa">inativa</span>
                        </span>
                        <span class="lista-dupla__botoes">
                          <button
                            type="button"
                            class="lista-dupla__mover"
                            :disabled="indice === 0"
                            :title="'Mover ' + rotuloOpcao(opcao) + ' para cima'"
                            :aria-label="'Mover ' + rotuloOpcao(opcao) + ' para cima'"
                            @click.stop="moverRetira(indice, -1)"
                          >
                            <fa-icon icon="arrow-up" />
                          </button>
                          <button
                            type="button"
                            class="lista-dupla__mover"
                            :disabled="indice === filiaisHabilitadas.length - 1"
                            :title="'Mover ' + rotuloOpcao(opcao) + ' para baixo'"
                            :aria-label="'Mover ' + rotuloOpcao(opcao) + ' para baixo'"
                            @click.stop="moverRetira(indice, 1)"
                          >
                            <fa-icon icon="arrow-down" />
                          </button>
                          <fa-icon icon="times" class="lista-dupla__acao" aria-hidden="true" />
                        </span>
                      </li>
                      <li v-if="!filiaisRetira.length" class="lista-dupla__vazio">
                        Clique nas filiais à esquerda para habilitar
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="section-label"
            role="button"
            tabindex="0"
            :aria-expanded="secoes.exibicao ? 'true' : 'false'"
            v-on:click="alternarSecao('exibicao')"
            @keydown.enter.prevent="alternarSecao('exibicao')"
            @keydown.space.prevent="alternarSecao('exibicao')"
          >
            <fa-icon icon="eye" class="section-label__icone" />
            Exibição
            <fa-icon
              :icon="secoes.exibicao ? 'chevron-up' : 'chevron-down'"
              class="section-label__seta"
            />
          </div>
          <div v-show="secoes.exibicao">
            <div class="xrow">
              <div class="col-1-4">
                <div class="form-group">
                  <label>Ordem de exibição</label>
                  <input type="number" min="0" class="form-control" v-model="filial.ordemexibicao" />
                </div>
              </div>
              <div class="col-3-4">
                <div class="toggle-row toggle-row--campo">
                  <span class="toggle-row__label">
                    Visível no VersoCommerce
                    <span class="toggle-row__hint">Exibe a filial na página de filiais do site</span>
                  </span>
                  <label class="toggle-switch">
                    <input
                      type="checkbox"
                      :checked="+filial.visivel_site === 1"
                      @change="filial.visivel_site = $event.target.checked ? 1 : 0"
                    />
                    <span class="toggle-slider"></span>
                    <span class="toggle-text">{{ +filial.visivel_site === 1 ? "Sim" : "Não" }}</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="xrow">
              <div class="col-1-1">
                <div class="form-group">
                  <label>URL do Google Maps</label>
                  <input
                    class="form-control"
                    placeholder="https://maps.google.com/..."
                    v-model="filial.url_maps"
                  />
                </div>
              </div>
            </div>
            <div class="xrow">
              <div class="col-1-2">
                <ImagePicker v-model="filial.img" label="Imagem da filial" placeholder="URL da imagem" />
              </div>
            </div>
          </div>

          <div class="section-label"
            role="button"
            tabindex="0"
            :aria-expanded="secoes.integracao ? 'true' : 'false'"
            v-on:click="alternarSecao('integracao')"
            @keydown.enter.prevent="alternarSecao('integracao')"
            @keydown.space.prevent="alternarSecao('integracao')"
          >
            <fa-icon icon="plug" class="section-label__icone" />
            Integração
            <fa-icon
              :icon="secoes.integracao ? 'chevron-up' : 'chevron-down'"
              class="section-label__seta"
            />
          </div>
          <div v-show="secoes.integracao">
            <p class="secao-descricao">
              Em algumas integrações estes códigos também vêm do ERP e são regravados na
              sincronização.
            </p>
            <div class="xrow">
              <div class="col-1-3">
                <div class="form-group">
                  <label>Filial de destino</label>
                  <input class="form-control" v-model="filial.filialdestino_id" />
                </div>
              </div>
              <div class="col-1-3">
                <div class="form-group">
                  <label>Centro de custo</label>
                  <input class="form-control" v-model="filial.centrocusto_id" />
                </div>
              </div>
              <div class="col-1-3">
                <div class="form-group">
                  <label>Local de estoque</label>
                  <input class="form-control" v-model="filial.localestoque_id" />
                </div>
              </div>
            </div>
            <div class="xrow">
              <div class="col-1-2">
                <div class="form-group">
                  <label for="filial-api-token">Token da API do ERP</label>
                  <div class="token-estado">
                    <span
                      class="token-estado__selo"
                      :class="{ 'token-estado__selo--definido': tokenDefinido }"
                    >
                      {{ tokenDefinido ? "Definido" : "Não definido" }}
                    </span>
                    <button
                      v-if="possuiApiToken && !criando"
                      type="button"
                      class="token-estado__acao"
                      :aria-pressed="removerApiToken ? 'true' : 'false'"
                      @click="alternarRemocaoToken"
                    >
                      {{ removerApiToken ? "Manter token atual" : "Remover token" }}
                    </button>
                  </div>
                  <div class="campo-token">
                    <input
                      id="filial-api-token"
                      class="form-control"
                      autocomplete="new-password"
                      :placeholder="possuiApiToken ? 'Informe um novo token para substituir' : 'Informe o token'"
                      :type="mostrarToken ? 'text' : 'password'"
                      v-model="novoApiToken"
                      @input="removerApiToken = false"
                    />
                    <button
                      type="button"
                      class="campo-token__botao"
                      :title="mostrarToken ? 'Ocultar token' : 'Mostrar token'"
                      :aria-label="mostrarToken ? 'Ocultar token' : 'Mostrar token'"
                      :aria-pressed="mostrarToken ? 'true' : 'false'"
                      @click="mostrarToken = !mostrarToken"
                    >
                      <fa-icon :icon="mostrarToken ? 'eye-slash' : 'eye'" aria-hidden="true" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer-bar">
      <CButton variant="outline" color="secondary" @click="close">Fechar</CButton>
      <CButton color="primary" :disabled="salvando || !filial.id" @click="salvar">
        {{ criando ? "Cadastrar" : "Alterar" }}
      </CButton>
    </div>
  </modal>
</template>

<script>
import CloseModal from "../../components/CloseModal";
import ImagePicker from "../../components/ImagePicker";
import {
  habilitarRetira,
  lerFiliaisRetira,
  montarPayloadFilial,
  moverRetira,
  removerRetira,
} from "./helpers/filialPayload";

export default {
  name: "FilialEdit",
  components: {
    CloseModal,
    ImagePicker,
  },
  props: ["filiais", "salvarFilial"],
  data() {
    return {
      filial: {},
      criando: false,
      filiaisRetira: [],
      possuiApiToken: false,
      novoApiToken: "",
      removerApiToken: false,
      mostrarToken: false,
      buscaFilial: "",
      salvando: false,
      secoes: {
        dados: true,
        retirada: true,
        exibicao: true,
        integracao: false,
      },
    };
  },
  computed: {
    nomeFilial() {
      return this.filial.fantasia || this.filial.razaosocial || "";
    },
    opcoesFiliais() {
      return (this.filiais || []).map((filial) => ({
        id: String(filial.id),
        nome: filial.fantasia || filial.razaosocial || "",
        inativa: +filial.ativo !== 1,
      }));
    },
    filiaisDisponiveis() {
      const termo = this.buscaFilial.trim().toLowerCase();

      return this.opcoesFiliais.filter(
        (opcao) =>
          this.filiaisRetira.indexOf(opcao.id) < 0 &&
          (!termo || `${opcao.id} ${opcao.nome}`.toLowerCase().indexOf(termo) >= 0)
      );
    },
    tokenDefinido() {
      if (this.novoApiToken.trim() !== "") {
        return true;
      }
      return this.possuiApiToken && !this.removerApiToken;
    },
    filiaisHabilitadas() {
      return this.filiaisRetira.map(
        (id) =>
          this.opcoesFiliais.find((opcao) => opcao.id === id) || { id, nome: "", inativa: false }
      );
    },
  },
  methods: {
    abrir(filial) {
      this.criando = !filial;
      this.filial = filial ? { ...filial } : { ativo: 1, visivel_site: 0 };
      this.filiaisRetira = lerFiliaisRetira(this.filial.filiaisretiras_ids);
      this.possuiApiToken = !!this.filial.possui_api_token;
      this.novoApiToken = "";
      this.removerApiToken = false;
      this.mostrarToken = false;
      this.buscaFilial = "";
      this.secoes = {
        dados: this.criando,
        retirada: true,
        exibicao: true,
        integracao: false,
      };
      this.$modal.show("editFilial");
    },
    close() {
      this.$modal.hide("editFilial");
    },
    alternarSecao(secao) {
      this.secoes[secao] = !this.secoes[secao];
    },
    habilitarRetira(id) {
      this.filiaisRetira = habilitarRetira(this.filiaisRetira, id);
    },
    desabilitarRetira(id) {
      this.filiaisRetira = removerRetira(this.filiaisRetira, id);
    },
    moverRetira(indice, direcao) {
      this.filiaisRetira = moverRetira(this.filiaisRetira, indice, direcao);
    },
    rotuloOpcao(opcao) {
      return [opcao.id, opcao.nome].filter(Boolean).join(" - ");
    },
    alternarRemocaoToken() {
      this.removerApiToken = !this.removerApiToken;
      if (this.removerApiToken) {
        this.novoApiToken = "";
      }
    },
    async salvar() {
      const dados = montarPayloadFilial({
        filial: this.filial,
        criando: this.criando,
        filiaisRetira: this.filiaisRetira,
        novoApiToken: this.novoApiToken,
        removerApiToken: this.removerApiToken,
      });

      this.salvando = true;
      try {
        await this.salvarFilial(this.criando, dados, this.filial.id);
        this.close();
      } catch (error) {
        return;
      } finally {
        this.salvando = false;
      }
    },
  },
};
</script>

<style scoped>
.modalbox-content {
  padding-right: 21px;
}
.filial-cabecalho {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}
.filial-cabecalho__icone {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eef0f8;
  color: #3a3e81;
  font-size: 17px;
  flex-shrink: 0;
}
.filial-cabecalho__titulo {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #101828;
}
.filial-cabecalho__subtitulo {
  font-size: 12px;
  color: #667085;
}
.section-label {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-left: 3px solid #3a3e81;
  border-radius: 3px;
  background-color: #f2f4f7;
  font-size: 13px;
  font-weight: 700;
  color: #475467;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin: 22px 0 16px;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.15s ease;
}
.section-label:hover {
  background-color: #eaecf0;
}
.section-label:hover,
.section-label:hover .section-label__seta {
  color: #3a3e81;
}
.section-label::after {
  content: "";
  flex: 1;
  order: 1;
}
.section-label__seta {
  order: 2;
  font-size: 11px;
  color: #98a2b3;
  flex-shrink: 0;
}
.section-label__icone {
  color: #3a3e81;
  font-size: 13px;
  flex-shrink: 0;
}
.section-label--primeira {
  margin-top: 16px;
}
.secao-descricao {
  font-size: 12px;
  color: #667085;
  margin: -4px 0 14px;
}
.aviso-erp {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 14px;
  margin-bottom: 14px;
  border: 1px solid #d6e4ff;
  border-radius: 8px;
  background: #f5f8ff;
  font-size: 12px;
  color: #344054;
}
.aviso-erp__icone {
  color: #3a5bd9;
  margin-top: 2px;
  flex-shrink: 0;
}
.form-body .form-group {
  margin-bottom: 10px;
}
.form-body .form-group > label,
.form-body .input-picker >>> label {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 3px;
  display: block;
}
.form-body .form-control {
  font-size: 13px;
}
.token-estado {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
}
.token-estado__selo {
  padding: 1px 8px;
  border-radius: 10px;
  background: #f2f4f7;
  color: #667085;
  font-size: 11px;
  font-weight: 600;
}
.token-estado__selo--definido {
  background: #e7f6e9;
  color: #2e7d32;
}
.token-estado__acao {
  padding: 0;
  border: none;
  background: transparent;
  color: #d92d20;
  font-size: 12px;
  cursor: pointer;
}
.token-estado__acao:hover {
  text-decoration: underline;
}
.token-estado__acao:focus-visible {
  outline: 2px solid #3a3e81;
  outline-offset: 2px;
}
.campo-token {
  position: relative;
}
.campo-token .form-control {
  padding-right: 40px;
}
.campo-token__botao {
  position: absolute;
  top: 50%;
  right: 6px;
  transform: translateY(-50%);
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #667085;
  cursor: pointer;
}
.campo-token__botao:hover {
  background: #eef0f8;
  color: #3a3e81;
}
.campo-token__botao:focus-visible {
  outline: 2px solid #3a3e81;
  outline-offset: 1px;
}
.form-body .form-control[readonly] {
  background: #f9fafb;
  color: #475467;
}
.toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
}
.toggle-row--campo {
  margin-top: 14px;
}
.toggle-row__label {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 13px;
  color: #333;
}
.toggle-row__hint {
  font-size: 11px;
  color: #98a2b3;
  font-weight: 400;
}
.toggle-switch {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin: 0;
  flex-shrink: 0;
}
.toggle-switch input {
  display: none;
}
.toggle-slider {
  position: relative;
  width: 36px;
  height: 20px;
  background-color: #ccc;
  border-radius: 20px;
  transition: background-color 0.2s;
  flex-shrink: 0;
}
.toggle-slider::after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  background-color: #fff;
  border-radius: 50%;
  transition: transform 0.2s;
}
.toggle-switch input:checked + .toggle-slider {
  background-color: #3a3e81;
}
.toggle-switch input:checked + .toggle-slider::after {
  transform: translateX(16px);
}
.toggle-switch input:disabled + .toggle-slider {
  opacity: 0.6;
  cursor: not-allowed;
}
.toggle-text {
  font-size: 12px;
  color: #777;
  min-width: 28px;
}
.lista-dupla {
  border: 1px solid #e4e7ec;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}
.lista-dupla__cabecalho {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  background: #f9fafb;
  border-bottom: 1px solid #e4e7ec;
  font-size: 11px;
  font-weight: 700;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.lista-dupla__contador {
  background: #eef0f5;
  color: #667085;
  border-radius: 10px;
  padding: 1px 8px;
  font-size: 11px;
}
.lista-dupla__limpar {
  padding: 0;
  border: none;
  background: transparent;
  font-weight: 700;
  color: #d92d20;
  cursor: pointer;
  font-size: 11px;
  text-transform: none;
  letter-spacing: 0;
}
.lista-dupla__limpar:hover {
  text-decoration: underline;
}
.lista-dupla__limpar:focus-visible {
  outline: 2px solid #3a3e81;
  outline-offset: 2px;
}
.lista-dupla__busca {
  position: relative;
  border-bottom: 1px solid #f2f4f7;
}
.lista-dupla__busca-icone {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #98a2b3;
  font-size: 11px;
}
.lista-dupla__busca-input {
  width: 100%;
  border: none;
  outline: none;
  padding: 8px 12px 8px 32px;
  font-size: 12px;
  color: #344054;
}
.lista-dupla__itens {
  list-style: none;
  margin: 0;
  padding: 0;
  height: 240px;
  overflow-y: auto;
}
.lista-dupla__itens--sem-busca {
  height: 274px;
}
.lista-dupla__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 7px 12px;
  font-size: 12px;
  color: #344054;
  border-bottom: 1px solid #f2f4f7;
  cursor: pointer;
  transition: background 0.12s ease;
}
.lista-dupla__item:last-child {
  border-bottom: none;
}
.lista-dupla__item:hover {
  background: #f7f7fc;
}
.lista-dupla--vinculadas .lista-dupla__item:hover {
  background: #fdf6f5;
}
.lista-dupla__texto strong {
  color: #667085;
  margin-right: 4px;
}
.lista-dupla__ordem {
  display: inline-block;
  min-width: 24px;
  color: #3a3e81;
  font-weight: 700;
}
.lista-dupla__selo {
  margin-left: 6px;
  padding: 1px 7px;
  border-radius: 10px;
  background: #eef0f8;
  color: #3a3e81;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
}
.lista-dupla__selo--inativa {
  background: #fef0e6;
  color: #b54708;
}
.lista-dupla__item:focus-visible,
.section-label:focus-visible {
  outline: 2px solid #3a3e81;
  outline-offset: -2px;
}
.lista-dupla__botoes {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}
.lista-dupla__mover {
  width: 22px;
  height: 22px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #98a2b3;
  font-size: 10px;
  cursor: pointer;
}
.lista-dupla__mover:hover:not(:disabled) {
  background: #eef0f8;
  color: #3a3e81;
}
.lista-dupla__mover:disabled {
  opacity: 0.35;
  cursor: default;
}
.lista-dupla__acao {
  color: #98a2b3;
  flex-shrink: 0;
  margin-left: 4px;
}
.lista-dupla__item:hover .lista-dupla__acao {
  color: #3a3e81;
}
.lista-dupla--vinculadas .lista-dupla__item:hover .lista-dupla__acao {
  color: #d92d20;
}
.lista-dupla__vazio {
  padding: 16px 12px;
  font-size: 12px;
  color: #98a2b3;
  text-align: center;
  cursor: default;
}
.modal-footer-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid #e9ecef;
  background: #fff;
}
</style>
